import { solutions } from './solutionCatalog'

export type NavItem = {
  label: string
  href: string
  description?: string
}

export type NavMenu = {
  label: string
  /** Parent page. Menus without groups render as a direct link. */
  href: string
  items?: NavItem[]
  width?: string
  align?: 'left' | 'right'
}

/** Main navigation: Solutions · How It Works · Research · Projects · About (+ Contact button). */
export const mainMenu: NavMenu[] = [
  {
    label: 'Solutions',
    href: '/solutions',
    width: 'w-64',
    items: [
      { label: 'All Solutions', href: '/solutions' },
      ...solutions.map((solution) => ({ label: solution.navLabel, href: solution.href })),
    ],
  },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'Research', href: '/research' },
  { label: 'Projects', href: '/projects' },
  {
    label: 'About',
    href: '/about',
    width: 'w-60',
    align: 'right',
    items: [
      { label: 'About SyNeural', href: '/about' },
      { label: 'Partnerships', href: '/partnerships' },
      { label: 'Investors', href: '/investors' },
    ],
  },
]

export type FooterLink = { label: string; href: string }

export const footerTagline = 'Connected knowledge. Capable people. Coordinated action.'

export const footerColumns: { heading: string; links: FooterLink[] }[] = [
  {
    heading: 'Solutions',
    links: solutions.map((solution) => ({ label: solution.navLabel, href: solution.href })),
  },
  {
    heading: 'Explore',
    links: [
      { label: 'How It Works', href: '/how-it-works' },
      { label: 'Demo Center', href: '/noetivra/demo-center' },
      { label: 'Research', href: '/research' },
      { label: 'Projects', href: '/projects' },
      { label: 'Roadmap', href: '/roadmap' },
    ],
  },
  {
    heading: 'SyNeural',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Partnerships', href: '/partnerships' },
      { label: 'Investors', href: '/investors' },
      { label: 'Contact', href: '/contact' },
    ],
  },
]
